module.exports = __webpack_public_path__ + "img/mob_product_05.7d6a81e3.png";